import { useTranslation } from 'react-i18next';

import React, { useEffect, useState,useContext, createContext } from "react";
import {Table, Modal, Button, } from "antd";
import { YhBox } from "@/erp_subpackage/components/YhBox";
import { YhPageHeader } from "@/erp_subpackage/components/YhPageHeader";
import {useContractModel} from '../contractParticularsModel'
import {usecontractDetailsModel} from './detailsModel'
import { formatNum } from '@/erp_subpackage/utils/util';
import i18n from 'i18next';

export const  DetaillModal =({mode,})=>{
    
    const  { visible,setVisible,loading,meilagedetialTotal,serachmdetail,updateSearchParamm,descTotalt,billdetailData,mileageOrderdetailes,resetSearchParamm,addFormVal,lookFormVal,editFormVal,
    } =usecontractDetailsModel()
   
    const formval = mode==='edit'?editFormVal:mode==='look'?lookFormVal:addFormVal
   


    const column = [
        {
            title: i18n.t(`contractManagement.view.detailorderModal.对账单单号`),
            width: 120,
            dataIndex: 'billCode',
            fixed: "left"
        },
        {
            title: i18n.t(`contractManagement.view.detailorderModal.车辆牌照`),
            width: 100,
            dataIndex: 'vehicleCode',
            
        },
        {
            title: i18n.t(`contractManagement.view.detailorderModal.上月账单里程`),
            width: 100,
            dataIndex: 'mileageLast',
            render:(text)=>text.toFixed(2)
        }, {
            title: i18n.t(`contractManagement.view.detailorderModal.当前里程`),
            width: 100,
            dataIndex: 'mileageCurrent',
            render:(text)=>text.toFixed(2)
        },
        {
            title: i18n.t(`contractManagement.view.detailorderModal.运行里程`),
            width: 100,
            dataIndex: 'mileageDiff',
            render:(text)=>text.toFixed(2)
        }, {
            title: i18n.t(`contractManagement.view.detailorderModal.计费价格`),
            width: 100,
            dataIndex: 'billPrice',
            render:(text)=>text.toFixed(3)
        }, {
            title: i18n.t(`contractManagement.view.detailorderModal.账单金额`),
            width: 100,
            dataIndex: 'totalAmount',   
            render:(text)=>text.toFixed(2)
        }, {
            title: i18n.t(`contractManagement.view.detailorderModal.已收金额`),
            width: 100,
            dataIndex: 'paidAmount',
            render:(text)=>text.toFixed(2)
          
        },{
            title: i18n.t(`contractManagement.view.detailorderModal.应收金额`),
            width: 100,
            dataIndex: 'payableAmount',
            render:(text)=>text.toFixed(2)
           
            
        },
        {
            title: i18n.t(`contractManagement.view.detailorderModal.开始日期`),
            width: 150,
            dataIndex: 'billStartTime',
            
        },
        {
            title: i18n.t(`contractManagement.view.detailorderModal.结束日期`),
            width: 150,
            dataIndex: 'billEndTime',
           
            
        },
       
    ];
    const desc = [
    
        {
            label: i18n.t(`contractManagement.view.detailorderModal.费用金额`),
           value: "￥" + (meilagedetialTotal.totalAmount?? 0).toFixed(2),
            color: "red"
        },
        {
            label: i18n.t(`contractManagement.view.detailorderModal.已收金额`), 
            value: "￥" + (meilagedetialTotal.paidAmount?? 0).toFixed(2),
            color: "red"
        }, {
            label: i18n.t(`contractManagement.view.detailorderModal.应收金额`),
            
         value: "￥" + (meilagedetialTotal.payableAmount?? 0).toFixed(2),
            color: "red"
        },
        
    ]
    

        const searchFields1 = [ 
            {
                type: "Input",
                placeholder: i18n.t(`contractManagement.view.detailorderModal.车辆牌照`),
                fieldName: "vehicleCode"
            }, 
        ]
        
    return(
        <>
        <Modal
         title= {i18n.t(`contractManagement.view.detailorderModal.对账单信息`)}
         open={visible}
         onCancel={() => setVisible(false)}
         width={1700}
         footer={[]}
        >
       <YhBox descriptions={desc}>
        <div style={{marginLeft:'28px',marginTop:'-44px'}}>    
          <YhPageHeader
               size="small"
               justify="end"
               triggerSearch
               searchValues={serachmdetail}
               searchFields={searchFields1}
               onChange={updateSearchParamm}
               handleSearch={() => { mileageOrderdetailes({ ...serachmdetail,}) }}
               handleReset={resetSearchParamm}
            /> 
         </div>
            <Table
             rowKey={record => record.id}
               columns={column}  
               loading={loading}  
               scroll={{ x: 'max-content' }}
               dataSource={billdetailData}
            />
       
         </YhBox>
        </Modal>
        </>
    )
}